import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faEdit } from '@fortawesome/free-solid-svg-icons'
import IconButton from '@material-ui/core/IconButton'
import CircularProgress from '@material-ui/core/CircularProgress'

import { TableHead, TableTitle } from '../../common'

import * as Strings from './strings'
import * as Functions from '../../../helpers/Functions'
import * as configActions from '../../actions/Config'
import * as bookingSystemActions from '../../actions/BookingSystems'
import * as Constants from '../../../helpers/Constants'
import * as bookingSystemTimesActions from '../../actions/BookingSystemTimes'

const CELL_WIDTH = 300
const ROWS = [
  {
    id: 'start',
    label: Strings.default.START_TIME,
    numeric: false,
    sortType: 'string'
  },
  {
    id: 'end',
    label: Strings.default.END_TIME,
    numeric: false,
    sortType: 'string'
  }
]

class BookingSystemsTable extends Component {
  state = {
    orderBy: 'start',
    order: 'asc',
    sortType: 'string'
  }

  desc(a, b, orderBy, sortType) {
    if (sortType === 'integer') {
      return b[orderBy] - a[orderBy]
    }

    if (sortType === 'boolean') {
      if (a[orderBy] && !b[orderBy]) {
        return 1
      } else if (!a[orderBy] && b[orderBy]) {
        return -1
      }

      return 0
    }

    if (b[orderBy] < a[orderBy]) {
      return -1
    } else if (b[orderBy] > a[orderBy]) {
      return 1
    }

    return 0
  }

  stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index])

    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0])

      if (order !== 0) {
        return order
      }

      return a[1] - b[1]
    })

    return stabilizedThis.map(el => el[0])
  }

  getSorting(order, orderBy, sortType) {
    return order === 'desc'
      ? (a, b) => this.desc(a, b, orderBy, sortType)
      : (a, b) => -this.desc(a, b, orderBy, sortType)
  }

  render() {
    const { orderBy, order, sortType } = this.state
    const { classes, data, user } = this.props

    if (!data.bookingSystemsFetched) {
      return (
        <div
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            marginTop: 125
          }}
        >
          <CircularProgress
            style={{ color: '#3b424d' }}
            thickness={2}
            size={75}
          />
        </div>
      )
    }

    return (
      <div>
        <Paper className={classes.root}>
          <TableTitle
            classes={classes}
            onIconClick={() => this.props.showCreateBookingSystemModal()}
            header={Strings.default.MANAGE_GENERAL_BOOKING_SYSTEMS}
            iconLabel={Strings.default.NEW_BOOKING_SYSTEM}
          />
          <p style={Styles.informationStyle}>
            {Strings.default.MANAGE_GENERAL_BOOKING_SYSTEMS_INFO}
          </p>
        </Paper>
        {data.bookingSystems.map(item => {
          const system = item.bookableObject

          const systemSettings = [
            {
              name: Strings.default.BOOKING_RANGE,
              value: Functions.bookingRangeToString(system.bookingRange)
            },
            {
              name: Strings.default.MAX_BOOKINGS,
              value: Functions.maxBookingsToString(system.maxBookings)
            }
          ]

          return (
            <Paper style={{ marginTop: 15 }}>
              <TableTitle
                classes={classes}
                addIcon={false}
                header={system.name}
                customButtons={[
                  {
                    label: 'Ändra',
                    onClick: () =>
                      this.props.showEditBookingSystemModal(system),
                    icon: faEdit,
                    color: '#3B424D'
                  },
                  {
                    label: 'Ta bort',
                    onClick: () => {
                      this.props.showAlert(
                        Strings.default.DELETE_BOOKING_SYSTEM +
                          '"' +
                          system.name +
                          '"',
                        Strings.default.DELETE_BOOKING_SYSTEM_INFO,
                        Constants.TWO_BUTTONS,
                        {
                          title: Strings.default.NO,
                          onPress: () => {}
                        },
                        {
                          title: Strings.default.YES,
                          onPress: () =>
                            this.props.tryDeleteBookingSystem(
                              user.token,
                              system.id
                            )
                        }
                      )
                    },
                    icon: faTrash,
                    color: '#e57373'
                  }
                ]}
                withBottomBorder
              />
              <Table className={classes.table} aria-labelledby={'tableTitle'}>
                <TableBody>
                  {systemSettings.map((setting, index) => {
                    return (
                      <TableRow key={index} className={classes.row}>
                        <TableCell style={{ width: CELL_WIDTH }}>
                          {setting.name}
                        </TableCell>
                        <TableCell style={{ width: CELL_WIDTH }}>
                          {setting.value}
                        </TableCell>
                        <TableCell />
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
              <TableTitle
                classes={classes}
                header={Strings.default.TIMES}
                onIconClick={() =>
                  this.props.showCreateBookingSystemTimeModal(system.id)
                }
                iconLabel={'Ny tid'}
              />
              <Table className={classes.table} aria-labelledby={'tableTitle'}>
                <TableHead
                  rows={ROWS}
                  order={order}
                  orderBy={orderBy}
                  sortOn={(newOrderBy, newOrder, newSortType) =>
                    this.setState({
                      orderBy: newOrderBy,
                      order: newOrder,
                      sortType: newSortType
                    })
                  }
                />
                <TableBody>
                  {this.stableSort(
                    system.times,
                    this.getSorting(order, orderBy, sortType)
                  ).map(time => {
                    return (
                      <TableRow key={time.id} className={classes.row}>
                        <TableCell style={{ width: CELL_WIDTH }}>
                          {time.start}
                        </TableCell>
                        <TableCell style={{ width: CELL_WIDTH }}>
                          {time.end}
                        </TableCell>
                        <TableCell numeric>
                          <IconButton
                            aria-label={'Ändra'}
                            onClick={() =>
                              this.props.showEditBookingSystemTimeModal(
                                system.id,
                                time
                              )
                            }
                          >
                            <FontAwesomeIcon
                              icon={faEdit}
                              color={'#3B424D'}
                              style={{ fontSize: 16 }}
                            />
                          </IconButton>
                          <IconButton
                            aria-label={'Ta bort'}
                            onClick={() =>
                              this.props.showAlert(
                                Strings.default.DELETE_BOOKING_SYSTEM_TIME,
                                Strings.default.DELETE_BOOKING_SYSTEM_TIME_INFO,
                                Constants.TWO_BUTTONS,
                                {
                                  title: Strings.default.NO,
                                  onPress: () => {}
                                },
                                {
                                  title: Strings.default.YES,
                                  onPress: () =>
                                    this.props.tryDeleteBookingSystemTime(
                                      user.token,
                                      system.id,
                                      time.id
                                    )
                                }
                              )
                            }
                          >
                            <FontAwesomeIcon
                              icon={faTrash}
                              color={'#e57373'}
                              style={{ fontSize: 16 }}
                            />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </Paper>
          )
        })}
      </div>
    )
  }
}

const Styles = {
  root: {
    width: '100%',
    overflowX: 'auto'
  },
  table: {
    minWidth: 700
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#fafafa'
    }
  },
  spacer: {
    flex: '1 1 100%'
  },
  actions: {
    color: 'green'
  },
  title: {
    flex: '0 0 auto'
  },
  headerStyle: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '1.3125rem',
    fontWeight: 500
  },
  informationStyle: {
    color: 'rgba(0, 0, 0, 0.54)',
    margin: 24
  }
}

BookingSystemsTable.propTypes = {
  classes: PropTypes.object.isRequired
}

function mapStateToProps({ data, user }) {
  return { data, user }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...configActions, ...bookingSystemActions, ...bookingSystemTimesActions },
    dispatch
  )
}

export default compose(
  withStyles(Styles),
  connect(mapStateToProps, mapDispatchToProps)
)(BookingSystemsTable)



// WEBPACK FOOTER //
// ./src/components/containers/BookingSystemsTable/index.js